export default __webpack_public_path__ + "static/media/darkness.e139e037.svg";